import { createContext, Dispatch, SetStateAction, useContext, useEffect, useMemo, useState } from 'react';
import { defaultProfessional, Professional, UserAllowedToPrescript } from '../interface/interface';

type ProfessionalDataFormProps = {
    profileData: Professional,
    setProfileData: Dispatch<SetStateAction<Professional>>,
    secretary: UserAllowedToPrescript | null,
    setSecretary: Dispatch<SetStateAction<UserAllowedToPrescript | null>>,
    errorProfileDataFields: boolean,
    setErrorProfileDataFields: Dispatch<SetStateAction<boolean>>,
    goBack: () => void,
    activeView: number,
    setActiveView: Dispatch<SetStateAction<number>>,
    subActiveView: number,
    setSubActiveView: Dispatch<SetStateAction<number>>,
    prevActiveView: number,
    setPrevActiveView: Dispatch<SetStateAction<number>>,
    prevSubActiveView: number,
    setPrevSubActiveView: Dispatch<SetStateAction<number>>,
}

const ProfessionalDataContext = createContext<ProfessionalDataFormProps>({
    profileData: null,
    setProfileData: () => {},
    secretary: null,
    setSecretary: () => {},
    errorProfileDataFields: false,
    setErrorProfileDataFields: () => {},
    goBack: () => {},
    activeView: 0,
    setActiveView: () => {},
    subActiveView: 0,
    setSubActiveView: () => {},
    prevActiveView: 0,
    setPrevActiveView: () => {},
    prevSubActiveView: 0,
    setPrevSubActiveView: () => {},
});



export default function ProfessionalData(props: { children: React.ReactNode }) {
    const [profileData, setProfileData] = useState<Professional>(defaultProfessional)
    const [secretary, setSecretary] = useState<UserAllowedToPrescript | null>(null)
    const [errorProfileDataFields, setErrorProfileDataFields] = useState<boolean>(false);
    
    const [activeView, setActiveView] = useState<number| null>(null);
    const [subActiveView, setSubActiveView] = useState<number | null>(null);
    const [prevActiveView, setPrevActiveView] = useState<number | null>(null);
    const [prevSubActiveView, setPrevSubActiveView] = useState<number | null>(null);

    const goBack = () => {
        setSubActiveView(prevSubActiveView)
        setPrevSubActiveView(undefined)
        setActiveView(prevActiveView)
        setPrevActiveView(undefined)
    };

    return (
        <ProfessionalDataContext.Provider
            value={{
                profileData,
                setProfileData,
                secretary,
                setSecretary,
                errorProfileDataFields,
                setErrorProfileDataFields,
                goBack,
                activeView,
                setActiveView,
                subActiveView,
                setSubActiveView,
                prevActiveView,
                setPrevActiveView,
                prevSubActiveView,
                setPrevSubActiveView,
            }}
        >
            {props.children}
        </ProfessionalDataContext.Provider>
    );
}

export const useRecipeProfessionalData = () => useContext(ProfessionalDataContext)
export {ProfessionalData}